import AICloudDeveloperPage from "./AICloudDeveloperPage";

export default function GcpDeveloperPage() {
  return <AICloudDeveloperPage technology="gcp" />;
}
